export const isPhoneNumberString = (string: string) => /^\d+$/.test(string) && string.length === 11;
